/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Macro_FatInputs */

const en_platform_macro_fat = /** @type {(inputs: Platform_Macro_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fat`)
};

const pl_platform_macro_fat = /** @type {(inputs: Platform_Macro_FatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tłuszcze`)
};

/**
* | output |
* | --- |
* | "Fat" |
*
* @param {Platform_Macro_FatInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_macro_fat = /** @type {((inputs?: Platform_Macro_FatInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Macro_FatInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_macro_fat(inputs)
	return en_platform_macro_fat(inputs)
});